import React, { useState } from 'react';
import { Container, Row, Col, Form, Button, Modal } from 'react-bootstrap';
import axios from 'axios';
import axiosInstance from '../axiosConfig';  // Import the Axios instance

const ContactPage = () => {
  // State for form inputs
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  // State for handling modal (popup) visibility
  const [showModal, setShowModal] = useState(false);
  
  // State for handling submission feedback
  const [submitStatus, setSubmitStatus] = useState('');

  const baseURL = 'http://localhost:8000/';

  // Handle input change
  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setFormData({ ...formData, [id]: value });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // Send form data to the FastAPI backend
      //const response = await axios.post(`${baseURL}/api/contact`, formData);

      const response = await axiosInstance.contact('/login', formData);
  


      // Display the success message in modal
      setSubmitStatus('Nachricht erfolgreich abgeschickt. Wir melden uns bald bei Ihnen!');
      setShowModal(true);

      // Clear the form after submission
      setFormData({
        name: '',
        email: '',
        message: ''
      });
    } catch (error) {
      // Handle any errors
      console.error('Error submitting form:', error);
      setSubmitStatus('Failed to submit the form. Please try again.');
      setShowModal(true);
    }
  };

  // Handle closing the modal
  const handleCloseModal = () => setShowModal(false);

  return (
    <Container className="mt-5">
      <Row>
        <Col md={6}>
          <h1>Kontaktiere uns</h1>
          <p>Falls Sie eine Frage haben, schicken Sie uns eine Nachricht:</p>
          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="name" className="mb-3">
              <Form.Label>Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter your name"
                value={formData.name}
                onChange={handleInputChange}
                required
              />
            </Form.Group>
            <Form.Group controlId="email" className="mb-3">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                placeholder="Enter your email"
                value={formData.email}
                onChange={handleInputChange}
                required
              />
            </Form.Group>
            <Form.Group controlId="message" className="mb-3">
              <Form.Label>Message</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                placeholder="Your message"
                value={formData.message}
                onChange={handleInputChange}
                required
              />
            </Form.Group>
            <Button variant="primary" type="submit">Submit</Button>
          </Form>
        </Col>
      </Row>

      {/* Success/Error Modal */}
      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Nachricht Status</Modal.Title>
        </Modal.Header>
        <Modal.Body>{submitStatus}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default ContactPage;